import { useEffect } from 'react';
import { useFitText } from './hooks/use-fit-text';

export type PriceFontSizeWidthCheckProps = {
  readonly cardWidth: number;
  readonly formattedPrice: string;
  readonly onFontSizeHandler: (fontSize: string) => void;
};

export const PriceFontSizeWidthCheck = ({
  cardWidth,
  onFontSizeHandler,
  formattedPrice
}: PriceFontSizeWidthCheckProps) => {
  const { ref, fontSize } = useFitText({ resolution: 1 });

  useEffect(() => {
    onFontSizeHandler(fontSize);
  }, [fontSize]);

  return (
    <div style={{ fontSize: '3.375rem' }}>
      <div
        ref={ref}
        style={{
          fontSize,
          height: '60px',
          margin: 0,
          fontFamily: 'Charlie Display',
          fontWeight: 400,
          verticalAlign: 'center',
          textAlign: 'center',
          width: `${cardWidth * 0.9}px`,
          border: '2px solid red',
          position: 'absolute',
          left: '-9999999px',
          top: '-9999999px'
        }}
      >
        {formattedPrice}
        <span style={{ fontSize: '1rem' }}>USD</span>
      </div>
    </div>
  );
};
